const targets = document.querySelectorAll(".js-checkbox-card");

for (const target of targets) {

  target.addEventListener("click", function () {
    if (target.querySelector('input').checked == true) {
      target.querySelector('input').checked = false;
    } else {
      target.querySelector('input').checked = true;
    }
    event.preventDefault();
  });
}